import { Grid, Typography } from '@mui/material';
import { 
	Show, 
	SimpleShowLayout, 
	TextField, 
	DateField, 
	BooleanField, 
	NumberField,
	Labeled
} from 'react-admin';

const DatingEventShow = () => (
	<Show resource="dating-events">
		<SimpleShowLayout>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h6" gutterBottom>פרטי האירוע</Typography>
				</Grid>
				
				<Grid item xs={12} md={6}>
					<Labeled label="כותרת עברית">
						<TextField source="title" dir="rtl" />
					</Labeled>
				</Grid>
				
				<Grid item xs={12} md={6}>
					<Labeled label="כותרת אנגלית">
						<TextField source="title_english" dir="ltr" />
					</Labeled>
				</Grid>
				
				<Grid item xs={12}>
					<Labeled label="תיאור">
						<TextField source="description.he" dir="rtl" />
					</Labeled>
				</Grid>
				
				<Grid item xs={12} md={6}>
					<Labeled label="תאריך האירוע">
						<DateField source="time" />
					</Labeled>
				</Grid>
				
				<Grid item xs={12} md={6}>
					<Labeled label="כתובת">
						<TextField source="address" dir="rtl" />
					</Labeled>
				</Grid>
				
				<Grid item xs={12} md={6}>
					<Labeled label="מספר הזמנות מקסימלי">
						<NumberField source="limitInvatations" />
					</Labeled>
				</Grid>
				
				<Grid item xs={12} md={6}>
					<Labeled label="פעיל">
						<BooleanField source="isActive" />
					</Labeled>
				</Grid>
				
				<Grid item xs={12} md={6}>
					<Labeled label="נוצר בתאריך">
						<DateField source="createdAt" />
					</Labeled>
				</Grid>
				
				<Grid item xs={12} md={6}>
					<Labeled label="עודכן בתאריך">
						<DateField source="updatedAt" />
					</Labeled>
				</Grid>
			</Grid>
		</SimpleShowLayout>
	</Show>
);

export default DatingEventShow;
